import React from "react";
import { CircleCheckIcon } from "lucide-react";
import { SectionHeading } from "./SectionHeading";
import { BookCover } from "./BookCover";
import { OfferLink } from "./OfferLink";
import { collectionBenefits, volumes } from "../data/landing";
import { offer } from "../data/offer";
export function VolumesSection() {
  return <section className="bg-white" data-id="element-309" data-mp="7pxtwrp46u0f">
      <div className="mx-auto max-w-6xl px-5 py-16 md:py-24" data-id="element-310" data-mp="7nlb6cbj8fmb">
        <SectionHeading eyebrow="The Complete Collection" title={<>
              Discover What's Inside <span className="text-royal" data-id="element-312" data-mp="3c1t9qreh2mmb">WHY WE BELIEVE.</span>
            </>} subtitle={<p data-id="element-313" data-mp="3pwvps7d19scu">Six carefully organized digital volumes covering the questions Christian parents care about most.</p>} data-id="element-311" data-mp="3g5r9n4bmg1gf" />

        <ul className="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-3" data-id="element-314" data-mp="2xegj4o9t5qp2">
          {volumes.map(v => <li key={v.number} className="flex flex-col overflow-hidden rounded-3xl bg-canvas ring-1 ring-ink/5" data-id="element-315" data-mp="2sg6r2mjdr67o">
              <div className="px-6 pt-8" style={{
            backgroundColor: `${v.color}1A`
          }} data-id="element-316" data-mp="29eh1eiohf7ke">
                <div className="mx-auto w-[52%] translate-y-6" data-id="element-317" data-mp="2edtmaxvsm4kc">
                  <BookCover kicker={`Volume ${v.number}`} title={v.title} color={v.color} icon={v.icon} data-id="element-318" data-mp="2ec8s59de4nn0" />
                </div>
              </div>
              <div className="flex flex-1 flex-col p-6 pt-10" data-id="element-319" data-mp="2o3d7ia6zaaid">
                <p className="font-display text-xs font-extrabold uppercase tracking-[0.16em]" style={{
              color: v.color
            }} data-id="element-320" data-mp="1qgmmjo0oa1u3">
                  Volume {v.number}
                </p>
                <h3 className="mt-1.5 font-display text-xl font-extrabold leading-tight text-ink" data-id="element-321" data-mp="1vhttxlywkz08">{v.title}</h3>
                <p className="mt-2 leading-relaxed text-ink-soft" data-id="element-322" data-mp="24gfhjvj8f47v">{v.text}</p>
              </div>
            </li>)}
        </ul>

        <div className="mt-14 rounded-[2rem] bg-royal-light px-6 py-10 md:px-12" data-id="element-323" data-mp="3bsxqgt34t7rn">
          <ul className="mx-auto flex max-w-4xl flex-wrap justify-center gap-3" data-id="element-324" data-mp="3fv1e0g32s2ta">
            {collectionBenefits.map(b => <li key={b} className="flex items-center gap-2 rounded-full bg-white px-4 py-2.5 text-[15px] font-semibold text-navy" data-id="element-325" data-mp="1gpht6vnnss7t">
                <CircleCheckIcon className="h-5 w-5 shrink-0 text-leaf" strokeWidth={2.25} aria-hidden="true" data-id="element-326" data-mp="1bu2iudov1eg5" />
                {b}
              </li>)}
          </ul>
          <div className="mx-auto mt-8 max-w-md" data-id="element-327" data-mp="1ksxsjzr456o7">
            <OfferLink label={`Get My Complete Bundle for ${offer.price}`} data-id="element-328" data-mp="x2bsovr9ispa" />
          </div>
        </div>
      </div>
    </section>;
}